(function () {
  "use strict";
 
  /* ---------------------------------------------------------
     1. CONFIG
     --------------------------------------------------------- */
  var _el = document.getElementById("tmeCS");
  var _d = (_el && _el.dataset) || {};
  var CONFIG = {
    // All four are set in the theme editor, not here.
    endpoint: _d.endpoint || "",
    email: _d.email || "electrics@themusicemporium.com",
    showPrices: _d.prices === "true",
    formName: _d.formname || "Custom Shop Build Request"
  };
 
  var ASK = "No preference, let's discuss";
  var QUOTE = "Call for quote";
 
  /* ---------------------------------------------------------
     2. OPTION DATA  (MAP only. No NET values in this file.)
        o("Label", map) builds an option.
     --------------------------------------------------------- */
  function o(label, map) { return { label: label, map: map || 0 }; }
 
  var FAMILIES = [
    { id: "strat", label: "Stratocaster", blurb: "Six models, 1955 through 1969" },
    { id: "tele",  label: "Telecaster, Nocaster or Esquire", blurb: "Blackguard through Thinline" },
    { id: "jm",    label: "Jazzmaster, Jaguar or Bass VI", blurb: "Offset bodies, 1962 onward" },
    { id: "bass",  label: "Precision or Jazz Bass", blurb: "1955 through the mid seventies" }
  ];
 
  var MODELS = {
    strat: [
      o("1955 Stratocaster (Ash)", 4750), o("1956 Stratocaster (Alder)", 4500),
      o("Other 1950s Stratocaster (Alder)", 4500), o("1960 Stratocaster (Alder)", 4625),
      o("1963 Stratocaster (Alder)", 4625), o("1965 Stratocaster (Alder)", 4625),
      o("1966 Stratocaster (Alder, large headstock)", 4625),
      o("1969 Stratocaster (Alder, large headstock)", 4625),
      o("Other 1960s Stratocaster (Alder)", 4625)
    ],
    tele: [
      o("1951 Nocaster (Ash)", 4750), o("1952 Telecaster (Ash)", 4750),
      o("Other 1950s Telecaster (Ash)", 4750), o("1960 Telecaster (Alder)", 4500),
      o("1960 Telecaster Custom (Alder)", 4925), o("1963 Telecaster (Alder)", 4500),
      o("1967 Telecaster (Alder)", 4500), o("Other 1960s Telecaster (Alder)", 4500),
      o("1959 Esquire (Ash)", 4625), o("Other year Esquire, through 1969", 4625),
      o("Thinline Telecaster (Ash)", 5000)
    ],
    jm: [
      o("1962 Jazzmaster (Alder)", 5575), o("Other year Jazzmaster, through 1966", 5575),
      o("1962 Jaguar (Alder)", 5575), o("Other year Jaguar, through 1965", 5575),
      o("Bass VI (Alder)", 6000)
    ],
    bass: [
      o("1955 Precision Bass (Ash)", 5050), o("1959 Precision Bass (Alder)", 4700),
      o("1960 Precision Bass (Alder)", 4700), o("Other year P Bass, through 1965", 4700),
      o("1964 Jazz Bass (Alder)", 4500), o("Other year J Bass, through 1965", 4500),
      o("1975 Jazz Bass (Ash)", 5550), o("Other 1970s J Bass, through 1974", 5550)
    ]
  };
 
  var PU = {
    stratHW: ["'50s", "Fat '50s", "'54", "'55", "'56", "'57", "'59", "'60", "Fat '60",
      "'60/'63", "'64", "Fat '64", "'65", "'66", "'69", "Texas Special", "Red Hot",
      "Troposphere", "Master Design Bone Tone", "Dual-Mag", "Dual-Mag II", "El Diablo",
      "Tomatillo"].map(function (n) { return o("Hand-wound " + n + " Strat", 0); })
      .concat([o("Hand-wound Ancho Poblano Strat", 90), o("Fender Vintage Noiseless", 90),
        o("Duncan SLDS-1 Hot Rails", 90), o("Duncan SSL-3 Hot Strat", 90),
        o("Duncan Li'l Screamin' Demon", 90), o("Duncan SLS-1 Lipstick Tube", 90)]),
    teleHW: ["Original Blackguard", "'50/'51 Blackguard", "'50/'51 Crushed Blackguard",
      "'51 Nocaster", "'51 Loaded Nocaster", "'55/'56", "'58", "'63", "'64", "'67",
      "Tomatillo", "Twisted", "Texas Special"].map(function (n) { return o("Hand-wound " + n + " Tele", 0); })
      .concat([o("Hand-wound Red Hot Tele", 90), o("Fender Vintage Noiseless", 90),
        o("Duncan Five-Two Tele", 135), o("Duncan Quarter Pound", 135), o("Duncan Little '59", 135)]),
    jmHW: [o("Hand-wound Vintage Jazzmaster", 0), o("Hand-wound Vintage Jaguar / Bass VI", 0)],
    bassHW: [o("Hand-wound '55 Precision", 0), o("Hand-wound '57 Precision", 0),
      o("Hand-wound '62 Precision", 0), o("Hand-wound '65-'70 Precision", 0),
      o("Hand-wound Vintage Jazz Bass", 0), o("Hand-wound '75 Jazz Bass", 0),
      o("Hand-wound Custom Classic Jazz Bass", 0)],
    buckers: [o("Fender Cunife Humbucker", 185), o("Fender Shawbucker", 90),
      o("EVH Wolfgang Humbucker", 135), o("EVH Frankenstein Humbucker", 135),
      o("Duncan SH-1 '59", 185), o("Duncan SH-55 Seth Lover", 410),
      o("Duncan SH-4 JB Bridge", 185), o("Duncan TB-4 Trembucker", 185),
      o("Duncan SH-PG1 Pearly Gates", 185), o("Duncan Antiquity Humbucker", 185),
      o("Duncan APH-1 Alnico II Pro", 185), o("Duncan TBAPH-1 Alnico II Pro", 185),
      o("Duncan Screamin' Demon", 185), o("Duncan SH-8 Invader", 185),
      o("Fender Custom P90", 90), o("Duncan Vintage P90", 135), o("Duncan Antiquity P90", 315)],
    tvjones: ["Classic", "Classic Plus", "Power 'Tron", "Power 'Tron Plus", "Super 'Tron", "Magna 'Tron"]
      .map(function (n) { return o("TV Jones " + n, 315); })
  };
 
  function pickupsFor(fam) {
    if (fam === "strat") return PU.stratHW.concat(PU.buckers);
    if (fam === "tele")  return PU.teleHW.concat(PU.buckers, PU.tvjones);
    if (fam === "jm")    return PU.jmHW.concat(PU.buckers);
    return PU.bassHW;
  }
 
  var PLY = [o("1-ply white"), o("1-ply eggshell"), o("1-ply parchment"), o("1-ply black"),
    o("1-ply black phenolic laminate"), o("3-ply white"), o("3-ply eggshell"),
    o("3-ply parchment"), o("3-ply mint green"), o("3-ply black"),
    o("3-ply white pearloid", 90), o("3-ply black pearloid", 90), o("4-ply brown shell", 90)];
 
  /* Sections. Each has: id, label, step, type, and optional fam filter.
     type: radio | select | checks | text | textarea | pickups | contact  */
  var SECTIONS = [
 
    /* --- STEP 1: instrument ------------------------------- */
    { id: "family", label: "Instrument", step: 1, type: "radio", required: true,
      options: FAMILIES.map(function (f) { return { label: f.label, value: f.id, blurb: f.blurb }; }),
      help: "Everything after this is filtered to fit what you pick here." },
 
    { id: "model", label: "Base model", step: 1, type: "select", required: true, dynamic: "models",
      help: "The year and body wood the build starts from." },
 
    { id: "buildLevel", label: "Build level", step: 1, type: "radio",
      options: [
        { label: "Team Built", value: "Team Built", blurb: "Built by the Custom Shop team to your spec" },
        { label: "Master-Built", value: "Master-Built", blurb: "One builder, start to finish, plus options only they can do", map: 3750 }
      ], help: "Master-Built unlocks a further set of options later in the form." },
 
    { id: "builder", label: "Preferred master builder", step: 1, type: "text",
      showIf: function (s) { return s.buildLevel === "Master-Built"; },
      placeholder: "Leave blank and we will suggest a fit" },
 
    { id: "aging", label: "Aging", step: 1, type: "select", options: [
      o("NOS, new old stock"), o("Time Capsule", 275), o("Closet Classic", 450),
      o("Closet Classic with NOS hardware", 400), o("Deluxe Closet Classic", 550),
      o("Journeyman Relic", 625), o("Journeyman Relic with Closet Classic hardware", 575),
      o("Relic", 775), o("Relic with Closet Classic hardware", 725),
      o("Heavy Relic", 1350), o("Heavy Relic with Closet Classic hardware", 1300),
      o("Super Heavy Relic", 1650)
    ], help: "How much wear the finish and hardware carry from day one." },
 
    /* --- STEP 2: body ------------------------------------- */
    { id: "bodyWood", label: "Body wood", step: 2, type: "select", options: [
      o("As the base model comes"), o("Alder"), o("Ash", 315), o("Eastern white pine", 185),
      o("Okoume", 185), o("Two-piece Fiji mahogany", 360), o("Roasted alder", 135),
      o("Roasted ash", 450), o("Roasted pine", 225)
    ]},
 
    { id: "bodyExtras", label: "Body construction", step: 2, type: "checks", options: [
      o("Left handed"), o("Sort for light weight", 185), o("Chambered body", 225),
      o("Hollow body with f-hole, arm contour", 315),
      o("Bound body top, no arm contour", 185), o("Bound body top and back, no contours", 315)
    ]},
 
    { id: "top", label: "Exotic top", step: 2, type: "select", options: [
      o("None"), o("Flame maple 2A", 625), o("Quilted maple 2A", 715), o("Spalted maple", 1085),
      o("Maple burl", 675), o("Buckeye burl", 900), o("Ziricote", 940), o("Cocobolo", 1085),
      o("Figured koa 4A", 1165)
    ]},
 
    { id: "color", label: "Colour", step: 2, type: "text",
      placeholder: "Fiesta Red, Sonic Blue, a photo you have seen, anything",
      help: "Name it however you like. We will match it to the Custom Shop chart." },
 
    { id: "colorTreat", label: "Colour treatment", step: 2, type: "select", options: [
      o("Single colour"), o("Colour over colour", 450), o("Sparkle", 575),
      o("Pink paisley, top", 185), o("Pink paisley, top and back", 360),
      o("Black paisley, top", 185), o("Black paisley, top and back", 360),
      o("Blue flower, top", 185), o("Blue flower, top and back", 360)
    ]},
 
    { id: "bodyFinish", label: "Body finish", step: 2, type: "select", options: [
      o("As the base model comes"), o("Nitrocellulose lacquer"),
      o("Nitro with white undercoat"), o("Flash coat lacquer", 90), o("Urethane")
    ]},
 
    /* --- STEP 3: neck ------------------------------------- */
    { id: "neckShape", label: "Neck shape", step: 3, type: "text",
      placeholder: "Soft V, chunky 59 D, or the thickness in inches at the 1st and 12th",
      help: "Describe it in your own words. This is the field worth being fussy about." },
 
    { id: "neckWood", label: "Neck wood", step: 3, type: "select", options: [
      o("As the base model comes, flat sawn maple"), o("Rift sawn maple", 90),
      o("Quartersawn maple", 90), o("Flame maple 2A", 265), o("Flame quartersawn maple 2A", 315),
      o("Flame maple 3A", 360), o("Birdseye maple 2A", 360), o("Birdseye maple 3A", 450),
      o("Roasted rift sawn maple", 185), o("Roasted quartersawn maple", 185),
      o("Roasted flame maple 3A", 550), o("Roasted birdseye maple 3A", 575),
      o("Indian rosewood", 400)
    ]},
 
    { id: "fbWood", label: "Fingerboard", step: 3, type: "select", options: [
      o("As the base model comes"), o("One-piece maple neck"), o("Slab rosewood or maple"),
      o("Round-lam rosewood or maple"), o("Sort for dark rosewood", 90),
      o("African blackwood", 225), o("Ebony", 135)
    ]},
 
    { id: "radius", label: "Fingerboard radius", step: 3, type: "select", options: [
      o("As the base model comes"), o("7.25 inch"), o("9.5 inch"), o("12 inch"),
      o("7.25 to 9.5 compound", 50), o("7.25 to 12 compound", 50),
      o("9.5 to 12 compound", 50), o("9.5 to 14 compound", 50)
    ], extra: { fam: ["bass"], option: o("9.5 to 16 compound, bass only", 50) }},
 
    { id: "nutWidth", label: "Width at the nut", step: 3, type: "select", options: [
      o("As the base model comes"), o("1.625 inch"), o("1.650 inch"),
      o("1.685 inch"), o("1.6875 inch")
    ]},
 
    { id: "nut", label: "Nut material", step: 3, type: "select", options: [
      o("As the base model comes"), o("Micarta"), o("Bone"), o("Graphite"),
      o("LSR roller nut, right handed and 1.6875 only", 90)
    ]},
 
    { id: "fretWire", label: "Fret wire", step: 3, type: "select", options: [
      o("As the base model comes"), o("Vintage style"), o("Medium vintage 47095"),
      o("Narrow tall 6105"), o("Medium jumbo 6150"), o("Jumbo 6100"),
      o("Medium stainless steel", 85), o("Jumbo stainless steel", 85)
    ]},
 
    { id: "neckExtras", label: "Neck details", step: 3, type: "checks", options: [
      o("Bound fingerboard", 540), o("Reverse headstock", 625), o("Contoured neck heel", 50),
      o("Matching painted headcap", 225), o("Scalloped fingerboard", 1000),
      o("22 frets, Strat and Tele only"), o("Bi-Flex truss rod, Strat and Tele headstock adjust")
    ]},
 
    { id: "neckFinish", label: "Neck finish and tint", step: 3, type: "select", options: [
      o("As the base model comes"), o("Nitro, no tint"), o("Nitro, light tint"),
      o("Nitro, medium tint"), o("Nitro, dark tint"), o("Satin lacquer", 50),
      o("Flash coat lacquer", 90), o("Gloss urethane", 50), o("Satin urethane", 50)
    ]},
 
    { id: "markers", label: "Position markers", step: 3, type: "select", options: [
      o("As the base model comes"), o("Black dots"), o("White dots"), o("Vintage clay dots"),
      o("Mother of pearl white dots"), o("Abalone dots", 50),
      o("Black opaque blocks", 575), o("Black poly pearl blocks", 575),
      o("White poly pearl blocks", 575), o("White mother of pearl blocks", 675)
    ]},
 
    /* --- STEP 4: hardware --------------------------------- */
    { id: "bridge", label: "Bridge", step: 4, type: "select", dynamic: "bridge" },
 
    { id: "tuners", label: "Tuning machines", step: 4, type: "select", options: [
      o("As the base model comes"), o("Vintage style"), o("Vintage style staggered", 50),
      o("Vintage style locking", 50), o("Vintage style F stamped", 90),
      o("Modern locking", 90), o("Modern locking staggered", 90)
    ]},
 
    { id: "hardwareColor", label: "Hardware colour", step: 4, type: "select", options: [
      o("As the base model comes"), o("Gold", 315)
    ]},
 
    { id: "pickguard", label: "Pickguard", step: 4, type: "select",
      options: [o("As the base model comes")].concat(PLY).concat([o("Anodized gold", 335)]) },
 
    { id: "backplate", label: "Backplate", step: 4, type: "select",
      options: [o("Match the pickguard")].concat(PLY) },
 
    { id: "neckPlate", label: "Neck plate", step: 4, type: "select", options: [
      o("As the base model comes, R serial"), o("V logo"), o("F logo"), o("F logo, contoured heel")
    ]},
 
    { id: "caseUpgrade", label: "Case", step: 4, type: "checks", fam: ["strat", "tele"],
      options: [o("Add the Anvil flight case", 2000)] },
 
    /* --- STEP 5: electronics ------------------------------ */
    { id: "pickups", label: "Pickups", step: 5, type: "pickups",
      help: "Leave any position blank and we will spec it to match the rest of the guitar." },
 
    { id: "josefina", label: "Winding", step: 5, type: "checks", options: [
      o("Josefina master wound upgrade, per pickup", 135)
    ]},
 
    { id: "wiring", label: "Wiring", step: 5, type: "select", dynamic: "wiring" },
 
    { id: "electronics", label: "Control options", step: 5, type: "checks", options: [
      o("Tone-Saver treble bleed", 90), o("Greasebucket tone control", 90),
      o("TBX tone control", 90), o("No-load tone control", 90), o("S-1 switch", 90),
      o("Three-way switch, Strat"), o("Reverse Tele control plate", 90),
      o("Reverse angle bridge pickup rout", 50)
    ]},
 
    { id: "knobs", label: "Control knobs", step: 5, type: "select", dynamic: "knobs" },
 
    { id: "covers", label: "Pickup covers", step: 5, type: "select", fam: ["strat"], options: [
      o("As the base model comes"), o("White"), o("Eggshell white"), o("Parchment white"),
      o("Vintage white"), o("Black"), o("Lipstick covers, each", 50)
    ]},
 
    /* --- STEP 6: master-built + notes --------------------- */
    { id: "mbOnly", label: "Master-Built only options", step: 6, type: "checks",
      showIf: function (s) { return s.buildLevel === "Master-Built"; },
      options: [
        o("Ultimate Relic", 2175), o("Specified maximum weight", 1800),
        o("Specified relic pattern", 550), o("Set neck", 450),
        o("Rosewood body", 1125), o("AAAA flame maple neck", 550),
        o("AAAA birdseye maple neck", 625), o("AAAA flame maple top", 900),
        o("Painted neck", 225), o("Custom compound fingerboard radius", 90),
        o("Colour match to a sample you provide", 1250), o("Gold leaf finish", 1975),
        { label: "Double neck", map: 0, quote: true },
        { label: "Custom colour paisley finish", map: 0, quote: true }
      ],
      help: "Certain woods, finishes, pickup configurations and wiring are available at this level only."
    },
 
    { id: "budget", label: "Rough budget", step: 6, type: "select", options: [
      o("Under 6,000"), o("6,000 to 8,000"), o("8,000 to 12,000"),
      o("12,000 to 20,000"), o("Above 20,000"), o("Tell me what this comes to")
    ], help: "Helps us steer you toward or away from options before you fall in love with them." },
 
    { id: "timing", label: "When do you need it", step: 6, type: "select", options: [
      o("No deadline"), o("Within six months"), o("Within a year"),
      o("For a specific date, noted below")
    ], help: "Custom Shop lead times run long and vary by builder." },
 
    { id: "notes", label: "Anything else", step: 6, type: "textarea",
      placeholder: "The guitar you are trying to recapture, a player whose tone you are after, a spec you could not find above, questions for us." },
 
    /* --- STEP 7: contact ---------------------------------- */
    { id: "contact", label: "Your details", step: 7, type: "contact", required: true }
  ];
 
  var STEP_NAMES = ["Instrument", "Body", "Neck", "Hardware", "Electronics", "Details", "Send"];
 
  function bridgeFor(fam) {
    if (fam === "strat") return [o("As the base model comes"),
      o("American Vintage synchronized tremolo"), o("Custom Shop vintage Strat tremolo", 50),
      o("Two-point Classic Player tremolo"), o("Two-point Custom Classic tremolo", 315),
      o("RSD Strat tremolo", 135), o("Vintage hard-tail", 50),
      o("Custom Classic hard-tail", 50), o("Floyd Rose double locking", 450)];
    if (fam === "tele") return [o("As the base model comes"),
      o("1951 to 1953 brass saddles"), o("1954 to 1957 steel saddles"),
      o("1958 to 1963 threaded saddles"), o("1964 to 1966 threaded saddles"),
      o("1967 slotted steel saddles"), o("Custom Deluxe Tele bridge", 135),
      o("RSD Tele bridge", 185), o("RSD hardtail, sawed off Tele", 50),
      o("Bigsby B-5 vibrato tailpiece", 360)];
    if (fam === "bass") return [o("As the base model comes"), o("Vintage two-saddle"),
      o("Vintage threaded saddles"), o("Vintage groove saddles"),
      o("American Deluxe"), o("RSD bass bridge", 265)];
    return [o("As the base model comes"), o("RSD J-bridge", 135)];
  }
 
  function wiringFor(fam) {
    if (fam === "strat") return [o("As the base model comes"), o("Vintage Strat"), o("Modern Strat"),
      o("Vintage Modified #1"), o("Vintage Modified #2 with Tone-Saver"),
      o("Strat blender", 90), o("Strat blender with Greasebucket", 90),
      o("Fat '50s Strat", 90), o("Fat '50s with Greasebucket", 90),
      o("Fat '50s half blender", 90), o("HSS PoMo Strat 250/500", 90),
      o("HSH configuration", 90), o("HH configuration", 90)];
    if (fam === "tele") return [o("As the base model comes"), o("Vintage Esquire, one pickup"),
      o("Full Throttle Esquire", 90), o("Cocked-wah Esquire", 90),
      o("1951 Nocaster blackguard"), o("1951 Modified Nocaster"),
      o("1953 to 1959 vintage Tele"), o("Modern Tele"),
      o("Modern Tele with Greasebucket", 90), o("Modern Tele with four-way switch", 90),
      o("Fat '50s Tele", 90), o("Hotshot Tele, three pickups", 90),
      o("HS Tele dual-stack 250/500", 90), o("Fat '50s dual P90 or HH Tele", 90)];
    if (fam === "bass") return [o("As the base model comes"),
      o("Vintage Jazz Bass with concentric knobs", 90)];
    return [o("As the base model comes")];
  }
 
  function knobsFor(fam) {
    if (fam === "strat") return [o("As the base model comes"), o("White"), o("Eggshell"),
      o("Parchment"), o("Vintage white"), o("Black")];
    if (fam === "tele" || fam === "bass") return [o("As the base model comes"),
      o("Vintage knurled"), o("Aluminium knurled")];
    return [o("As the base model comes")];
  }
 
  function positionsFor(fam) {
    if (fam === "strat") return ["Neck", "Middle", "Bridge"];
    if (fam === "bass") return ["Neck", "Bridge"];
    return ["Neck", "Bridge"];
  }
 
  /* ---------------------------------------------------------
     3. STATE + RENDER
     --------------------------------------------------------- */
  var state = {};
  var step = 1;
  var MAXSTEP = 7;
 
  var root = document.getElementById("tmeCS");
  var panels = document.getElementById("tmePanels");
  var stepsNav = document.getElementById("tmeSteps");
  var summaryEl = document.getElementById("tmeSummary");
  var estimateEl = document.getElementById("tmeEstimate");
  var statusEl = document.getElementById("tmeStatus");
 
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
 
  function priceTag(opt) {
    if (!CONFIG.showPrices) return "";
    if (opt.quote) return '<span class="tme-cs__price">' + QUOTE + "</span>";
    if (!opt.map) return "";
    return '<span class="tme-cs__price">+$' + opt.map.toLocaleString() + "</span>";
  }
 
  function optionsFor(sec) {
    if (sec.dynamic === "models") return MODELS[state.family] || [];
    if (sec.dynamic === "bridge") return bridgeFor(state.family);
    if (sec.dynamic === "wiring") return wiringFor(state.family);
    if (sec.dynamic === "knobs") return knobsFor(state.family);
    var list = (sec.options || []).slice();
    if (sec.extra && sec.extra.fam.indexOf(state.family) > -1) list.push(sec.extra.option);
    return list;
  }
 
  function visible(sec) {
    if (sec.fam && sec.fam.indexOf(state.family) === -1) return false;
    if (sec.showIf && !sec.showIf(state)) return false;
    if (sec.step > 1 && !state.family) return false;
    return true;
  }
 
  function render() {
    var html = "";
    SECTIONS.forEach(function (sec) {
      if (sec.step !== step || !visible(sec)) return;
      html += '<fieldset class="tme-cs__field" data-id="' + sec.id + '">';
      html += '<legend class="tme-cs__legend">' + esc(sec.label) +
        (sec.required ? ' <span class="tme-cs__req">required</span>' : "") + "</legend>";
      if (sec.help) html += '<p class="tme-cs__help">' + esc(sec.help) + "</p>";
      html += renderControl(sec);
      html += "</fieldset>";
    });
    if (!html) html = '<p class="tme-cs__help">Nothing to choose on this step for the instrument you picked. Keep going.</p>';
    panels.innerHTML = html;
    bind();
    paintSteps();
    paintSummary();
    document.getElementById("tmePrev").disabled = step === 1;
    document.getElementById("tmeNext").hidden = step === MAXSTEP;
    document.getElementById("tmeSend").hidden = step !== MAXSTEP;
  }
 
  function renderControl(sec) {
    var opts = optionsFor(sec);
    var v = state[sec.id];
    var h = "";
 
    if (sec.type === "radio") {
      h += '<div class="tme-cs__cards">';
      opts.forEach(function (opt, i) {
        var val = opt.value || opt.label;
        h += '<label class="tme-cs__card' + (v === val ? " is-on" : "") + '">' +
          '<input type="radio" name="' + sec.id + '" value="' + esc(val) + '"' +
          (v === val ? " checked" : "") + '>' +
          '<span class="tme-cs__card-t">' + esc(opt.label) + priceTag(opt) + "</span>" +
          (opt.blurb ? '<span class="tme-cs__card-b">' + esc(opt.blurb) + "</span>" : "") +
          "</label>";
      });
      h += "</div>";
 
    } else if (sec.type === "select") {
      h += '<select class="tme-cs__select" name="' + sec.id + '">';
      h += '<option value="">' + ASK + "</option>";
      opts.forEach(function (opt) {
        var val = opt.value || opt.label;
        var t = opt.label + (CONFIG.showPrices && opt.map ? "  (+$" + opt.map.toLocaleString() + ")" : "");
        h += '<option value="' + esc(val) + '"' + (v === val ? " selected" : "") + ">" + esc(t) + "</option>";
      });
      h += "</select>";
 
    } else if (sec.type === "checks") {
      var arr = v || [];
      h += '<div class="tme-cs__checks">';
      opts.forEach(function (opt) {
        var on = arr.indexOf(opt.label) > -1;
        h += '<label class="tme-cs__check' + (on ? " is-on" : "") + '">' +
          '<input type="checkbox" name="' + sec.id + '" value="' + esc(opt.label) + '"' +
          (on ? " checked" : "") + '><span>' + esc(opt.label) + priceTag(opt) + "</span></label>";
      });
      h += "</div>";
 
    } else if (sec.type === "text") {
      h += '<input class="tme-cs__input" type="text" name="' + sec.id + '" value="' +
        esc(v || "") + '" placeholder="' + esc(sec.placeholder || "") + '">';
 
    } else if (sec.type === "textarea") {
      h += '<textarea class="tme-cs__input tme-cs__textarea" name="' + sec.id +
        '" rows="5" placeholder="' + esc(sec.placeholder || "") + '">' + esc(v || "") + "</textarea>";
 
    } else if (sec.type === "pickups") {
      var list = pickupsFor(state.family);
      var pos = positionsFor(state.family);
      var cur = state.pickups || {};
      h += '<div class="tme-cs__pups">';
      pos.forEach(function (p) {
        h += '<label class="tme-cs__pup"><span class="tme-cs__pup-l">' + p + "</span>" +
          '<select class="tme-cs__select" data-pos="' + p + '"><option value="">' + ASK + "</option>";
        list.forEach(function (opt) {
          var t = opt.label + (CONFIG.showPrices && opt.map ? "  (+$" + opt.map.toLocaleString() + ")" : "");
          h += '<option value="' + esc(opt.label) + '"' +
            (cur[p] === opt.label ? " selected" : "") + ">" + esc(t) + "</option>";
        });
        h += "</select></label>";
      });
      h += "</div>";
 
    } else if (sec.type === "contact") {
      var c = state.contact || {};
      h += '<div class="tme-cs__grid">' +
        inp("name", "Name", c.name, "text", true) +
        inp("email", "Email", c.email, "email", true) +
        inp("phone", "Phone", c.phone, "tel") +
        inp("city", "City and state", c.city, "text") +
      "</div>";
      h += '<label class="tme-cs__check' + (c.optin ? " is-on" : "") +
        '" style="margin-top:14px"><input type="checkbox" data-c="optin"' +
        (c.optin ? " checked" : "") + '><span>Send me occasional news about Custom Shop arrivals at the shop</span></label>';
    }
    return h;
  }
 
  function inp(k, label, val, type, req) {
    return '<label class="tme-cs__lab">' + label + (req ? ' <span class="tme-cs__req">required</span>' : "") +
      '<input class="tme-cs__input" type="' + type + '" data-c="' + k + '" value="' + esc(val || "") + '"></label>';
  }
 
  function bind() {
    panels.querySelectorAll('input[type=radio]').forEach(function (el) {
      el.addEventListener("change", function () {
        var prev = state[el.name];
        state[el.name] = el.value;
        if (el.name === "family" && prev && prev !== el.value) resetSpec();
        render();
      });
    });
    panels.querySelectorAll('select[name]').forEach(function (el) {
      el.addEventListener("change", function () { state[el.name] = el.value; paintSummary(); });
    });
    panels.querySelectorAll('input[type=checkbox][name]').forEach(function (el) {
      el.addEventListener("change", function () {
        var arr = state[el.name] || [];
        var i = arr.indexOf(el.value);
        if (el.checked && i === -1) arr.push(el.value);
        if (!el.checked && i > -1) arr.splice(i, 1);
        state[el.name] = arr;
        el.closest(".tme-cs__check").classList.toggle("is-on", el.checked);
        paintSummary();
      });
    });
    panels.querySelectorAll('input[type=text][name], input[type=email][name], textarea[name]').forEach(function (el) {
      el.addEventListener("input", function () { state[el.name] = el.value; paintSummary(); });
    });
    panels.querySelectorAll('select[data-pos]').forEach(function (el) {
      el.addEventListener("change", function () {
        state.pickups = state.pickups || {};
        state.pickups[el.getAttribute("data-pos")] = el.value;
        paintSummary();
      });
    });
    panels.querySelectorAll('[data-c]').forEach(function (el) {
      el.addEventListener(el.type === "checkbox" ? "change" : "input", function () {
        state.contact = state.contact || {};
        state.contact[el.getAttribute("data-c")] = el.type === "checkbox" ? el.checked : el.value;
        if (el.type === "checkbox") el.closest(".tme-cs__check").classList.toggle("is-on", el.checked);
      });
    });
  }
 
  function resetSpec() {
    var keep = { family: state.family, buildLevel: state.buildLevel, contact: state.contact };
    state = keep;
  }
 
  function paintSteps() {
    var h = "";
    for (var i = 1; i <= MAXSTEP; i++) {
      h += '<button type="button" class="tme-cs__step' + (i === step ? " is-on" : "") +
        (i < step ? " is-done" : "") + '" data-step="' + i + '"' +
        (i > 1 && !state.family ? " disabled" : "") + '>' +
        '<span class="tme-cs__step-n">' + i + "</span>" + STEP_NAMES[i - 1] + "</button>";
    }
    stepsNav.innerHTML = h;
    stepsNav.querySelectorAll("button").forEach(function (b) {
      b.addEventListener("click", function () {
        step = parseInt(b.getAttribute("data-step"), 10); render(); scrollTop();
      });
    });
  }
 
  /* Build the human-readable spec. Used for the sidebar, the
     clipboard copy, and the email body. One source of truth. */
  function specLines() {
    var out = [];
    SECTIONS.forEach(function (sec) {
      if (sec.type === "contact" || !visible(sec)) return;
      var v = state[sec.id];
      if (sec.type === "pickups") {
        var p = state.pickups || {}, bits = [];
        positionsFor(state.family).forEach(function (k) { if (p[k]) bits.push(k + ": " + p[k]); });
        if (bits.length) out.push(["Pickups", bits.join("  /  ")]);
        return;
      }
      if (!v || (Array.isArray(v) && !v.length)) return;
      if (sec.id === "family") {
        var f = FAMILIES.filter(function (x) { return x.id === v; })[0];
        out.push([sec.label, f ? f.label : v]);
        return;
      }
      out.push([sec.label, Array.isArray(v) ? v.join(", ") : v]);
    });
    return out;
  }
 
  function estimate() {
    var total = 0, quote = false;
    function add(label, list) {
      list.forEach(function (opt) {
        if (opt.label === label || opt.value === label) {
          if (opt.quote) quote = true; else total += opt.map || 0;
        }
      });
    }
    SECTIONS.forEach(function (sec) {
      if (!visible(sec)) return;
      var v = state[sec.id];
      var opts = optionsFor(sec);
      if (Array.isArray(v)) v.forEach(function (x) { add(x, opts); });
      else if (v) add(v, opts);
    });
    if (state.pickups) {
      var list = pickupsFor(state.family);
      Object.keys(state.pickups).forEach(function (k) { add(state.pickups[k], list); });
    }
    return { total: total, quote: quote };
  }
 
  function paintSummary() {
    var lines = specLines();
    if (!lines.length) {
      summaryEl.innerHTML = '<p class="tme-cs__sheet-empty">Choose an instrument to start the sheet.</p>';
      estimateEl.hidden = true;
      return;
    }
    summaryEl.innerHTML = lines.map(function (l) {
      return '<div class="tme-cs__row"><span class="tme-cs__row-k">' + esc(l[0]) +
        '</span><span class="tme-cs__row-v">' + esc(l[1]) + "</span></div>";
    }).join("");
    if (CONFIG.showPrices) {
      var e = estimate();
      estimateEl.hidden = false;
      estimateEl.innerHTML = "Indicative MAP, before tax and case: <strong>$" +
        e.total.toLocaleString() + "</strong>" + (e.quote ? " plus quoted items" : "") +
        '<br><span class="tme-cs__fine">Not a quote. The Custom Shop confirms final pricing.</span>';
    } else {
      estimateEl.hidden = true;
    }
  }
 
  /* Klaviyo lists each property as its own row and its email templates
     cannot render newlines, so a single spec blob is unreadable there.
     Send every spec field as a discrete property instead, plus a
     spec_lines array that an alert email can loop over. */
  function klaviyoProps() {
    var c = state.contact || {};
    var props = {
      form: CONFIG.formName,
      name: c.name || "", email: c.email || "", phone: c.phone || "",
      location: c.city || "", optin: !!c.optin
    };
    var lines = [];
    specLines().forEach(function (l) {
      props[l[0]] = l[1];
      lines.push(l[0] + ": " + l[1]);
    });
    props.spec_lines = lines;
    return props;
  }
 
  function specText() {
    var lines = specLines();
    var c = state.contact || {};
    var t = "CUSTOM SHOP BUILD REQUEST\n";
    t += "Received " + new Date().toLocaleString() + "\n\n";
    t += "CUSTOMER\n";
    t += "Name: " + (c.name || "") + "\nEmail: " + (c.email || "") +
      "\nPhone: " + (c.phone || "") + "\nLocation: " + (c.city || "") +
      "\nMarketing opt-in: " + (c.optin ? "yes" : "no") + "\n\nSPEC\n";
    lines.forEach(function (l) { t += l[0] + ": " + l[1] + "\n"; });
    t += "\nUnlisted fields were left open for discussion.\n";
    return t;
  }
 
  function scrollTop() {
    root.scrollIntoView({ behavior: prefersReduced() ? "auto" : "smooth", block: "start" });
  }
  function prefersReduced() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
 
  function validate() {
    var c = state.contact || {};
    if (!state.family) return "Pick an instrument on step one first.";
    if (!state.model) return "Choose a base model on step one.";
    if (!c.name) return "Add your name so we know who to reply to.";
    if (!c.email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(c.email)) return "Add a valid email address.";
    return null;
  }
 
  document.getElementById("tmeNext").addEventListener("click", function () {
    if (step === 1 && !state.family) { statusEl.textContent = "Pick an instrument to continue."; return; }
    statusEl.textContent = "";
    if (step < MAXSTEP) { step++; render(); scrollTop(); }
  });
  document.getElementById("tmePrev").addEventListener("click", function () {
    if (step > 1) { step--; render(); scrollTop(); }
  });
  document.getElementById("tmeCopy").addEventListener("click", function () {
    navigator.clipboard.writeText(specText()).then(function () {
      var b = document.getElementById("tmeCopy");
      b.textContent = "Copied"; setTimeout(function () { b.textContent = "Copy spec to clipboard"; }, 1800);
    });
  });
 
  document.getElementById("tmeSend").addEventListener("click", function () {
    var err = validate();
    if (err) { statusEl.textContent = err; statusEl.className = "tme-cs__status is-err"; return; }
    if (document.querySelector('[name=company_website]').value) return; // bot
 
    var c = state.contact || {};
    var payload = {
      form: CONFIG.formName,
      name: c.name, email: c.email, phone: c.phone || "", location: c.city || "",
      optin: !!c.optin,
      instrument: state.family, model: state.model,
      spec: specText(),
      spec_json: JSON.stringify({ state: state })
    };
 
    var btn = this;
    btn.disabled = true;
    statusEl.className = "tme-cs__status";
    statusEl.textContent = "Sending your spec.";
 
    if (!CONFIG.endpoint) {
      window.location.href = "mailto:" + CONFIG.email +
        "?subject=" + encodeURIComponent("Custom Shop build request from " + (c.name || "a customer")) +
        "&body=" + encodeURIComponent(specText());
      statusEl.textContent = "Your email client should be opening. If it does not, copy the spec and send it to " + CONFIG.email + ".";
      btn.disabled = false;
      return;
    }
 
    // Klaviyo's client events endpoint needs a JSON:API envelope and a
    // revision header. Anything else gets the flat payload above.
    var isKlaviyo = CONFIG.endpoint.indexOf("klaviyo.com/client/events") > -1;
    var headers = { "Content-Type": "application/json" };
    var body = payload;
 
    if (isKlaviyo) {
      // Pin this to whatever revision is current in Klaviyo's reference.
      headers.revision = "2026-07-15";
      var nameBits = (c.name || "").trim().split(/\s+/);
      var profile = { email: c.email };
      if (nameBits[0]) profile.first_name = nameBits[0];
      if (nameBits.length > 1) profile.last_name = nameBits.slice(1).join(" ");
      // Phone stays out of the profile: Klaviyo requires E.164 and will
      // reject the whole request on a badly formatted number. It is still
      // in the event properties below.
      body = {
        data: {
          type: "event",
          attributes: {
            metric: { data: { type: "metric", attributes: { name: CONFIG.formName } } },
            profile: { data: { type: "profile", attributes: profile } },
            properties: klaviyoProps()
          }
        }
      };
    } else {
      headers.Accept = "application/json";
    }
 
    fetch(CONFIG.endpoint, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) {
        return r.text().then(function (t) {
          throw new Error("HTTP " + r.status + " " + r.statusText + " :: " + (t || "(empty response body)"));
        });
      }
      root.querySelector(".tme-cs__body").innerHTML =
        '<div class="tme-cs__done"><h2>Your spec is with us.</h2>' +
        "<p>We will read through it and get back to you at " +
        esc(c.email) + " with pricing, lead time and any questions about the parts you left " +
        "open. Thanks for thinking of us for this one.</p></div>";
      root.querySelector(".tme-cs__steps").hidden = true;
      scrollTop();
    }).catch(function (err) {
      // Full detail to the console so a failure is diagnosable. The message
      // shown to the customer stays plain on purpose.
      console.group("[Custom Shop form] submission failed");
      console.error("Reason:", (err && err.message) ? err.message : err);
      console.error("Endpoint:", CONFIG.endpoint || "(not set)");
      console.error("Klaviyo mode:", isKlaviyo);
      console.error("Request headers:", headers);
      console.error("Request body:", body);
      console.error("A TypeError with no status usually means the request never "
        + "reached the server: a wrong or unreachable URL, or a CORS rejection.");
      console.groupEnd();
      statusEl.className = "tme-cs__status is-err";
      statusEl.textContent = "That did not send. Use the copy button to grab your spec and email it to " + CONFIG.email + " and we will pick it up from there.";
      btn.disabled = false;
    });
  });
 
  render();
})();